import { render, staticRenderFns } from "./MentionPanelToolbar.vue?vue&type=template&id=72df1ef5&scoped=true"
import script from "./MentionPanelToolbar.vue?vue&type=script&lang=js"
export * from "./MentionPanelToolbar.vue?vue&type=script&lang=js"
import style0 from "./MentionPanelToolbar.vue?vue&type=style&index=0&id=72df1ef5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df1ef5",
  null
  
)

export default component.exports